import React, { SyntheticEvent, useState } from 'react'
import styles from './UploadImg.module.scss'
import {
  useUploadFeaturesImageMutation,
  useDeleteFeaturesImageMutation,
} from './service'
import { LoadingButton } from '@mui/lab'
import { useForm } from 'react-hook-form'
import { useParams } from 'react-router-dom'
import { Dialog } from '@/components'
interface Props {
  url: string
}

const UploadFeaturesImg = ({ url }: Props) => {
  const { id } = useParams()
  const [imgUrl, setImgUrl] = useState(url)
  const [openDialogSave, setOpenDialogSave] = useState(false)
  const [loading, setLoading] = useState(false)
  const { register } = useForm()
  const [addImage] = useUploadFeaturesImageMutation()
  const [deleteImage] = useDeleteFeaturesImageMutation()
  const handleRemovePhoto = async () => {
    setLoading(true)
    try {
      await deleteImage({ deviceId: Number(id) })
      setImgUrl('')
    } catch (e) {
      console.log(e)
    } finally {
      setLoading(false)
      setOpenDialogSave(false)
    }
  }
  const handleAddPhoto = async (e: SyntheticEvent) => {
    const { files } = e.target as HTMLInputElement
    if (e.target && files?.length) {
      setLoading(true)
      try {
        const file = files[0]
        const formData = new FormData()
        // @ts-ignore
        formData.append('deviceId', id)
        formData.append('image', files[0])
        const { data } = (await addImage(formData)) as any
        console.log('data', data)
        setImgUrl(data?.imgUrl || '')
      } catch (e) {
        console.log(e)
      } finally {
        setLoading(false)
      }
    }
  }

  return (
    <>
      <Dialog
        message='Изображение будет удалено. Вы уверены?'
        open={openDialogSave}
        handleClose={() => setOpenDialogSave(false)}
        handleAgree={() => {
          handleRemovePhoto()
        }}
      />
      <div className={styles.Wrapper}>
        {imgUrl && (
          <div>
            <img
              className={styles.UploadedImage}
              src={imgUrl}
              alt=''
            />
          </div>
        )}
        <div>
          <LoadingButton
            variant={'text'}
            component='label'
            loading={loading}
          >
            Загрузить {!imgUrl && ' изображение'}
            <form>
              <input
                id='photosInput'
                type='file'
                hidden
                accept='.jpg, .jpeg, .png, .gif'
                {...register('file', { onChange: handleAddPhoto })}
              />
            </form>
          </LoadingButton>
          <br />
          {imgUrl && (
            <LoadingButton
              variant={'text'}
              component='label'
              loading={loading}
              color='error'
              onClick={() => setOpenDialogSave(true)}
            >
              Удалить
            </LoadingButton>
          )}
        </div>
      </div>
    </>
  )
}

export default UploadFeaturesImg
